<template>
  <div id="not-found" class="m-3">
    <h4>The content you are looking for cannot be found or doesn't exist.</h4>
  </div>
</template>

<script>
export default {
  name: 'not-found',
};
</script>

<style lang="scss"></style>
